module.exports = __webpack_public_path__ + "webStatic/img/logo_2.324ce33d.png";